var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5417 8.32433L6.17825 13.1729C5.99929 13.3718 5.69254 13.3879 5.49377 13.2089C5.28416 13.0189 5.28825 12.7123 5.45778 12.5235L9.52971 8.00008L5.45772 3.47573C5.27955 3.27572 5.29531 2.97087 5.49347 2.79086C5.69254 2.61207 5.99917 2.62813 6.17825 2.82693L10.5414 7.64825C10.7084 7.86068 10.7084 8.13948 10.5417 8.32433Z",
    fill: "#09193A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.d5dff3b2e5e274ac6750269b673c2c30.svg";
export { ForwardRef as ReactComponent };